import React from 'react'
import { MyImage } from '../ui/MyImage'
import { MyVipIcon } from '~/components/ui/MyVipIcon'
import classNames from 'classnames'
import { UserRoleType } from '~/utils'

export const MyAvatar: React.FC<{
  image: string
  userRole: UserRoleType | null | undefined
  size: number
  style?: React.CSSProperties
  hiddenIcon?: boolean
  className?: string
  iconClassName?: string
  iconBorder?: boolean
}> = ({
  image,
  size,
  userRole,
  className,
  style,
  hiddenIcon = false,
  iconClassName,
  iconBorder = true,
}) => {
  return (
    <div
      style={{ height: size, width: size, ...style }}
      className={classNames('relative', className)}
    >
      <MyImage
        className="w-full h-full rounded-[50%]"
        src={image}
        tag="v400"
        dark
        alt=""
      />
      {!hiddenIcon && (
        <MyVipIcon
          userRole={userRole}
          border={iconBorder}
          className={classNames(
            'h-3 -right-1 bottom-0 max-w-[18px]',
            iconClassName
          )}
        />
      )}
    </div>
  )
}
